module.exports = __webpack_public_path__ + "img/error.31d43c58.png";